/* GENERATED by scripts/gen-data.mjs — the path: chapters, optional stages, bonus stage (from s2.js + s3.js).
 * Structure only: every string is an i18n key resolved from
 * src/i18n/locales/<lang>/. Edit the content in the artifact and re-run
 * npm run extract, do not hand-edit here. */

import type { NodeDef, Edge } from '../../types';
import { N_WHAT_AI_IS } from './01-what-ai-is';
import { N_MODEL_FAMILIES } from './02-model-families';
import { N_GROUNDING } from './03-grounding';
import { N_MEMORY } from './04-memory';
import { N_EVENT_BUS } from './05-event-bus';
import { N_SERVICE_SPLIT } from './06-service-split';
import { N_FRONTEND_COMPOSITION } from './07-frontend-composition';
import { N_TOOLING } from './08-tooling';
import { N_GUARDRAILS } from './09-guardrails';
import { N_EVALUATE } from './10-evaluate';
import { N_PRODUCTION } from './11-production';
import { N_DEPLOY } from './12-deploy';
import { N_MONITOR } from './13-monitor';
import { N_X_CURRICULUM } from './x-curriculum';
import { N_X_SOFTMAX } from './x-softmax';
import { N_X_DELIVERY } from './x-delivery';
import { N_X_CONTRACTS } from './x-contracts';
import { N_X_THREATS } from './x-threats';
import { N_X_DRIFT } from './x-drift';
import { N_X_COST } from './x-cost';
import { N_X_AGENTS } from './x-agents';
import { N_X_STRUCTURED } from './x-structured';
import { N_X_COMPLIANCE } from './x-compliance';
import { N_X_LATENCY } from './x-latency';
import { N_X_NATS } from './x-nats';
import { N_X_FEDERATION } from './x-federation';
import { N_BONUS_PIPELINE } from './bonus-pipeline';

export const NODES: NodeDef[] = [
  N_WHAT_AI_IS,
  N_MODEL_FAMILIES,
  N_GROUNDING,
  N_MEMORY,
  N_EVENT_BUS,
  N_SERVICE_SPLIT,
  N_FRONTEND_COMPOSITION,
  N_TOOLING,
  N_GUARDRAILS,
  N_EVALUATE,
  N_PRODUCTION,
  N_DEPLOY,
  N_MONITOR,
  N_X_CURRICULUM,
  N_X_SOFTMAX,
  N_X_DELIVERY,
  N_X_CONTRACTS,
  N_X_THREATS,
  N_X_DRIFT,
  N_X_COST,
  N_X_AGENTS,
  N_X_STRUCTURED,
  N_X_COMPLIANCE,
  N_X_LATENCY,
  N_X_NATS,
  N_X_FEDERATION,
  N_BONUS_PIPELINE,
];

export const EDGES: Edge[] = [
  [
    "what-ai-is",
    "model-families"
  ],
  [
    "model-families",
    "grounding"
  ],
  [
    "grounding",
    "memory"
  ],
  [
    "memory",
    "event-bus"
  ],
  [
    "event-bus",
    "service-split"
  ],
  [
    "service-split",
    "frontend-composition"
  ],
  [
    "service-split",
    "tooling"
  ],
  [
    "frontend-composition",
    "guardrails"
  ],
  [
    "tooling",
    "guardrails"
  ],
  [
    "guardrails",
    "evaluate"
  ],
  [
    "evaluate",
    "production"
  ],
  [
    "production",
    "deploy"
  ],
  [
    "deploy",
    "monitor"
  ]
];

export const EXTRA_EDGES: Edge[] = [
  [
    "what-ai-is",
    "x-curriculum"
  ],
  [
    "model-families",
    "x-softmax"
  ],
  [
    "event-bus",
    "x-delivery"
  ],
  [
    "service-split",
    "x-contracts"
  ],
  [
    "guardrails",
    "x-threats"
  ],
  [
    "evaluate",
    "x-drift"
  ],
  [
    "production",
    "x-cost"
  ],
  [
    "tooling",
    "x-agents"
  ],
  [
    "guardrails",
    "x-structured"
  ],
  [
    "production",
    "x-compliance"
  ],
  [
    "production",
    "x-latency"
  ],
  [
    "event-bus",
    "x-nats"
  ],
  [
    "frontend-composition",
    "x-federation"
  ]
];
